<template>
  <span>
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9995 3.22314H9.22184C4.77767 3.22314 3 5.00081 3 9.44499V14.778C3 19.2222 4.77767 20.9998 9.22184 20.9998H14.5549C18.999 20.9998 20.7767 19.2222 20.7767 14.778V13.0003" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.4794 4.12991L8.47533 11.1339C8.20868 11.4006 7.94203 11.925 7.8887 12.3072L7.5065 14.9826C7.36429 15.9514 8.04869 16.6269 9.01752 16.4936L11.6929 16.1114C12.0662 16.0581 12.5906 15.7914 12.8662 15.5248L19.8702 8.52076C21.079 7.31194 21.6479 5.90758 19.8702 4.12991C18.0925 2.35224 16.6882 2.9211 15.4794 4.12991Z" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.4751 5.13477C15.0706 7.25908 16.7327 8.9212 18.8659 9.52561" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
  }
}
</script>
